/**
 * Chrome API utilities.
 *
 * Provides safe access to Chrome extension APIs.
 */

// Chrome API type (simplified for our use case)
// Full types available via @types/chrome if needed
export interface ChromeApi {
  runtime: {
    sendMessage: (
      extensionId: string,
      message: any,
      callback?: (response: any) => void
    ) => void;
    connect: (
      extensionId: string,
      connectInfo?: { name?: string }
    ) => ChromePort;
    lastError?: { message?: string };
  };
}

export interface ChromePort {
  postMessage: (message: any) => void;
  disconnect: () => void;
  onMessage: {
    addListener: (callback: (message: any) => void) => void;
    removeListener: (callback: (message: any) => void) => void;
  };
  onDisconnect: {
    addListener: (callback: () => void) => void;
  };
}

/**
 * Get the Chrome API if available.
 * Returns null if not in a Chrome environment or API is unavailable.
 */
export function getChromeApi(): ChromeApi | null {
  if (typeof window === "undefined") return null;
  try {
    const anyWindow = window as any;
    const api = anyWindow?.chrome;
    // Verify essential APIs are present
    if (api?.runtime?.sendMessage) {
      return api;
    }
    return null;
  } catch {
    return null;
  }
}
